import { NBSP } from '../../../constants/symbols';
import { useApplicationContext } from '../../../utils/withApplicationContext';

interface IFallbackModalSettings {
  title: string;
  description: string;
  buttonText: string;
  imageUrl?: string;
}

const DEFAULT_SETTINGS: IFallbackModalSettings = {
  title: 'Что-то пошло не так',
  description: `Проверьте интернет и${NBSP}попробуйте ещё${NBSP}раз`,
  buttonText: 'Повторить',
};

export const useFallbackModalSettings = (): IFallbackModalSettings => {
  const { config } = useApplicationContext();

  return config.get<IFallbackModalSettings>('newbuildingBroker.modalsMicrofrontFallback') ?? DEFAULT_SETTINGS;
};
